const faqs = [
  {
    q: '苹果视频需要注册吗？',
    a: '完全不需要。苹果视频坚持免费开放的理念，所有电影电视剧均可直接在线观看，无需注册、无需登录、无需付费。打开网页即点即看，方便快捷。',
  },
  {
    q: '支持哪些设备观看？',
    a: '苹果视频采用响应式设计，完美兼容手机、平板、笔记本电脑和台式电脑等所有设备。无需下载任何APP或插件，通过浏览器即可享受流畅的高清观影体验。',
  },
  {
    q: '视频画质如何？缓冲快吗？',
    a: '全站提供高清画质片源，同时采用多节点CDN智能加速技术，确保播放流畅不缓冲。无论是热门大片还是冷门剧集，都能获得稳定流畅的播放体验。',
  },
  {
    q: '资源多久更新一次？',
    a: '编辑团队每日更新200+影视资源，覆盖久久视频、芒果视频、97视频、丝瓜视频等平台最新内容。院线新片、热播剧集、综艺节目都会在第一时间上线。',
  },
  {
    q: '可以下载视频到本地吗？',
    a: '苹果视频为在线观看平台，不支持视频下载功能。您可以在有网络的环境下随时打开网站观看，所有资源均可无限次免费在线播放。',
  },
  {
    q: '遇到播放问题怎么办？',
    a: '如遇到播放卡顿或无法加载的情况，建议刷新页面或切换网络环境。苹果视频持续优化服务器性能，确保绝大多数用户都能获得流畅的观影体验。如有其他问题，欢迎通过页面底部联系方式联系我们。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-16 md:py-24 bg-white">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-serif text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            关于苹果视频，你想知道的都在这里
          </p>
        </div>
        <div className="max-w-3xl mx-auto grid grid-cols-1 gap-4">
          {faqs.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-50 border border-background-200/70 p-6"
            >
              <h3 className="text-base font-semibold text-foreground-950 mb-3 font-serif flex items-start gap-3">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-8">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}